import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Layouts from "../../layouts/layouts";
import Select from "react-select";

export default function Create_leaverestriction() {
  const title = "Add Leave Restriction ";
  const [clients, setClients] = useState([]);
  const [generalstafftypes, setGeneralstafftypes] = useState([]);

  const [formData, setFormData] = useState({
    id_generalStaffType: "",
    casualLeaveBalance: "",
    wfhBalance: "",
    weekendPolicy: "Sunday",
    description: "",
    id_client: "",
  });
  const [autocomplete, setAutocomplete] = useState(null);
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const brad = [{ name: "Home" }, { name: title }];
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchGenralstafftypes = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/general-staff-types`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data && response.data.generalStaffTypes) {
          setGeneralstafftypes(response.data.generalStaffTypes);
        } else {
          console.error("Unexpected response format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching staff types:", error);
      }
    };

    fetchGenralstafftypes();
  }, []);

  const handleStaffChange = (event) => {
    const { value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      id_generalStaffType: value,
    }));
  };

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.id_generalStaffType)
      newErrors.id_generalStaffType = "Staff Type is required";
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    const data = new FormData();
    data.append("id_generalStaffType", formData.id_generalStaffType);
    data.append("id_client", formData.id_client);
    data.append("casualLeaveBalance", formData.casualLeaveBalance);
    data.append("wfhBalance", formData.wfhBalance);
    data.append("weekendPolicy", formData.weekendPolicy);
    data.append("description", formData.description);

    for (let [key, value] of data.entries()) {
      console.log(`${key}: ${value}`);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v2/leave-restriction`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Response data:", response.data);

      if (response.status === 201) {
        navigate("/leaverestriction");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      //   console.error("Error:", error);

      console.error("Error:", error.response ? error.response.data : error);
    }
  };
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/clients`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data.clients);
        setClients(response.data.clients);
        console.log("Clients fetched:", response.data.clients);
      } catch (error) {
        console.error("Error fetching client:", error);
        setClients([]);
      }
    };
    fetchClients();
  }, []);
  const handleClientChange = (selectedOptions) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      id_client: selectedOptions
        ? selectedOptions.map((option) => option.value)
        : [],
    }));
  };
  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div className="">{title}</div>
            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>
          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-md-6 mt-3">
                <label htmlFor="id_generalStaffType">
                  <b>Staff Type *</b>
                </label>
                <select
                  name="id_generalStaffType"
                  className="form-control"
                  value={formData.id_generalStaffType}
                  onChange={handleStaffChange}
                >
                  <option value="">Select Staff Type</option>
                  {Array.isArray(generalstafftypes) &&
                    generalstafftypes.map((generalstafftype) => (
                      <option
                        key={generalstafftype._id}
                        value={generalstafftype._id}
                      >
                        {generalstafftype.name}
                      </option>
                    ))}
                </select>
                {errors.id_generalStaffType && (
                  <p className="text-danger">{errors.id_generalStaffType}</p>
                )}
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="id_client">
                  <b>Client * </b>
                </label>
                <Select
                  name="id_client"
                  options={clients.map((client) => ({
                    value: client._id,
                    label: `${client.name}`,
                  }))}
                  isMulti
                  onChange={handleClientChange}
                  className={`basic-multi-select ${
                    errors.id_client ? "is-invalid" : ""
                  }`}
                  classNamePrefix="select"
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="id_employee">
                  <b>Basic Pay *</b>
                </label>
                <input
                  type="number"
                  name="basic_pay"
                  placeholder="Basic Pay"
                  className="form-control"
                  value={formData.basic_pay}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="casualLeaveBalance">
                  <b> Casual Leave Balance </b>
                </label>
                <input
                  type="number"
                  name="casualLeaveBalance"
                  placeholder="Casual Leave Balance "
                  className="form-control"
                  value={formData.casualLeaveBalance}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="wfhBalance">
                  <b>WFH Balance *</b>
                </label>
                <input
                  type="number"
                  name="wfhBalance"
                  placeholder="WFH Balance"
                  className="form-control"
                  value={formData.wfhBalance}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="weekendPolicy">
                  <b>Weekend Policy *</b>
                </label>
                <select
                  name="weekendPolicy"
                  className="form-control"
                  value={formData.weekendPolicy}
                  onChange={onChangeHandler}
                >
                  <option value="">Select Weekend Policy</option>
                  <option value="None">None</option>
                  <option value="Sunday">Sunday</option>
                  <option value="Saturday-Sunday">Saturday-Sunday</option>
                </select>
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="Description">
                  <b>Description </b>
                </label>
                <input
                  type="text"
                  name="description"
                  placeholder="Description"
                  className="form-control"
                  value={formData.description}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3"></div>
            </div>
            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Add Leave Restriction
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
